import {IRegistryChangePasswordInitialValues} from "../../../../types/registry";

export default {
    newPassword: "",
    confirmPassword: ""
} as IRegistryChangePasswordInitialValues;
